export type CircleTimerProps = {
    current: number;          // 경과 시간(또는 현재 값)
    duration: number;         // 전체 시간
    size: number;
    color: string;            // 보라색(채워진 영역)
    backgroundColor: string;  // 배경 원 색
    direction?: 'clockwise' | 'counterclockwise'; // 시계방향 또는 반시계방향 (기본값: 'clockwise')
  };
  
  const clamp01 = (n: number) => Math.max(0, Math.min(1, n));
  
  function buildSectorPath(
    cx: number,
    cy: number,
    r: number,
    startAngle: number,
    sweepAngle: number, // 양수면 시계방향으로 채움
    sweepFlag: number   // 1 = 시계방향, 0 = 반시계방향
  ) {
    const endAngle = startAngle + sweepAngle;
  
    const sx = cx + r * Math.cos(startAngle);
    const sy = cy + r * Math.sin(startAngle);
    const ex = cx + r * Math.cos(endAngle);
    const ey = cy + r * Math.sin(endAngle);
  
    const largeArcFlag = Math.abs(sweepAngle) > Math.PI ? 1 : 0;
  
    return `M ${cx} ${cy} L ${sx} ${sy} A ${r} ${r} 0 ${largeArcFlag} ${sweepFlag} ${ex} ${ey} Z`;
  }
  
  const CircleTimer = ({
    current,
    duration,
    size,
    color,
    backgroundColor,
    direction = 'clockwise',
  }: CircleTimerProps) => {
    const elapsed = clamp01(duration > 0 ? current / duration : 0);
    const remaining = 1 - elapsed; // 남은 비율 (1에서 0으로 감소)
  
    const cx = size / 2;
    const cy = size / 2;
    const r = size / 2; // 꽉 찬 파이 형태
  
    // 12시 시작
    const startAngle = -Math.PI / 2;
  
    // 남은 만큼 채우기 (시계방향으로 줄어듦)
    const sweepAngle = direction === 'clockwise' 
      ? -remaining * 2 * Math.PI 
      : remaining * 2 * Math.PI; // 반시계방향은 음수
    const sweepFlag = direction === 'clockwise' ? 0 : 1; // 1 = 시계방향, 0 = 반시계방향
  
    const EPS = 1e-4;
  
    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* 배경 원 */}
        <circle cx={cx} cy={cy} r={r} fill={backgroundColor} />
  
        {/* 남은 영역(보라색) - 시계방향으로 줄어듦 */}
        {remaining >= 1 - EPS ? (
          // 360도(꽉 참)는 arc로 못 그리니 circle로 처리
          <circle cx={cx} cy={cy} r={r} fill={color} />
        ) : remaining <= EPS ? null : (
          <path
            d={buildSectorPath(cx, cy, r, startAngle, sweepAngle, sweepFlag)}
            fill={color}
          />
        )}
      </svg>
    );
  };
  
  export default CircleTimer;
  